/**
 * Landing Pages Configuration for Clinic Type SEO Pages
 *
 * Each clinic type gets a dedicated landing page at /for/:slug
 * with tailored content, sub-specializations, and SEO metadata.
 */

export const LANDING_PAGES = {
  speech_therapist: {
    slug: "speech-therapy",
    profession: "קלינאות תקשורת",
    professionShort: "קלינאיות תקשורת",
    heroTitle: "מערכת ניהול קליניקה לקלינאות תקשורת",
    heroSubtitle:
      "הפלטפורמה שנבנתה במיוחד עבור קלינאיות ו­קלינאים תקשורת. נהלו מטופלים, תעדו טיפולים עם AI ועקבו אחרי ההתקדמות — הכל בממשק אחד נוח.",
    metaTitle:
      "CliniKit - מערכת ניהול קליניקה לקלינאות תקשורת | תיעוד, יומן, AI",
    metaDescription:
      "מערכת ניהול קליניקה מתקדמת לקלינאיות תקשורת. ניהול מטופלים, סיכומי טיפול עם AI, יומן חכם, תזכורות SMS, ספריית משחקים ועוד. התחילו חינם.",
    color: "#6C63FF",
    emoji: "🗣️",
    intro:
      "CliniKit מותאמת לעבודה של קלינאיות ו­קלינאים תקשורת בכל תחומי ההתמחות — מגמגום ועיכוב שפתי ועד הפרעות קול ותקשורת חלופית. המערכת כוללת תבניות סיכום מותאמות, ספריית משחקים עם המלצות AI, וכלים לתיעוד התקדמות הטיפול.",
    specializations: [
      { name: "גמגום", desc: "תיעוד מפגשים, מעקב שטף דיבור לאורך זמן" },
      {
        name: "היגוי ומובנות דיבור",
        desc: "סיכומי טיפול מותאמים עם מעקב צלילים",
      },
      {
        name: "עיכוב שפתי",
        desc: "תבניות הערכה ראשונית ומעקב התפתחות שפתית",
      },
      { name: "דחיקת לשון", desc: "תיעוד תרגילים ומעקב התקדמות" },
      { name: "אוטיזם (ASD)", desc: "כלים ייעודיים למעקב תקשורת חברתית" },
      { name: "קשיי בליעה", desc: "תיעוד מפורט של הערכות בליעה" },
      { name: "הפרעות קול", desc: "מעקב איכות קול ותוצאות טיפול" },
      { name: "שטף דיבור", desc: "ניטור והערכת שטף לאורך זמן" },
      { name: "תקשורת חלופית (AAC)", desc: "תיעוד התאמת מכשירים ומעקב שימוש" },
      { name: "אפזיה", desc: "הערכות שפתיות ותיעוד שיקומי" },
      { name: "אפרקסיה", desc: "מעקב מוטורי-דיבורי ותרגילים" },
      { name: "חך שסוע", desc: "תיעוד מסלול טיפולי מורכב" },
      { name: "לקויות שמיעה", desc: "שילוב עם מעקב שמיעה ואודיולוגיה" },
      { name: "תפקודי פה", desc: "הערכת מנגנון פה ותיעוד טיפולים" },
    ],
    features: [
      {
        title: "ספריית משחקים עם AI",
        desc: "נהלו ספריית משחקים ופעילויות, קבלו המלצות AI מותאמות למטרות הטיפול ולגיל המטופל.",
      },
      {
        title: "תבניות סיכום מותאמות",
        desc: "תבניות סיכום טיפול מותאמות לתחומי קלינאות תקשורת — גמגום, שפה, היגוי ועוד.",
      },
      {
        title: "מעקב התקדמות",
        desc: "עקבו אחרי ההתקדמות של כל מטופל עם סיכומים חכמים שמתעדכנים אוטומטית.",
      },
      {
        title: "יומן חכם + תזכורות",
        desc: "יומן עם SMS אוטומטי ואישורי הגעה בוואטסאפ. ניהול חדרי טיפול לקליניקות.",
      },
    ],
    testimonialQuote:
      "CliniKit חסכה לי שעות של עבודה שבועית. הסיכומים עם AI מדהימים.",
    testimonialAuthor: "רונית כ., קלינאית תקשורת",
  },

  occupational_therapist: {
    slug: "occupational-therapy",
    profession: "ריפוי בעיסוק",
    professionShort: "מרפאים בעיסוק",
    heroTitle: "מערכת ניהול קליניקה לריפוי בעיסוק",
    heroSubtitle:
      "מערכת שמבינה את העבודה של מרפאים בעיסוק. תועדו טיפולים, נהלו מטופלים ועקבו אחרי ההתקדמות — הכל בממשק אחד.",
    metaTitle: "CliniKit - מערכת ניהול קליניקה לריפוי בעיסוק | מטופלים, AI, יומן",
    metaDescription:
      "מערכת ניהול קליניקה למרפאים בעיסוק. התפתחות הילד, ויסות חושי, מוטוריקה עדינה, שיקום נוירולוגי. סיכומי AI, יומן, תשלומים. התחילו חינם.",
    color: "#F59E42",
    emoji: "🤲",
    intro:
      "CliniKit מותאמת למרפאים ולמרפאות בעיסוק בכל תחומי ההתמחות — מהתפתחות הילד וויסות חושי ועד שיקום נוירולוגי וגריאטריה. תועדו טיפולים עם תבניות מקצועיות, קבלו סיכומי AI אוטומטיים ועקבו אחרי ההתקדמות של כל מטופל.",
    specializations: [
      {
        name: "התפתחות הילד",
        desc: "תבניות הערכה התפתחותית ומעקב אבני דרך",
      },
      {
        name: "ויסות חושי",
        desc: "כלים לתיעוד פרופיל חושי ותוכניות התערבות",
      },
      {
        name: "כתיבה ומוטוריקה עדינה",
        desc: "מעקב מיומנויות מוטוריות עדינות ושיפור כתיבה",
      },
      {
        name: "שיקום נוירולוגי",
        desc: "תיעוד מסלול שיקומי ומעקב יעדים פונקציונליים",
      },
      {
        name: "גריאטריה",
        desc: "כלים למעקב תפקוד יומיומי ואיכות חיים",
      },
    ],
    features: [
      {
        title: "סיכומי טיפול עם AI",
        desc: "AI שמבין את התחום שלכם ומסכם טיפולים בצורה מקצועית ומדויקת.",
      },
      {
        title: "תיעוד התקדמות",
        desc: "מעקב אחרי יעדים טיפוליים, אבני דרך והתקדמות לאורך זמן.",
      },
      {
        title: "ניהול מטופלים מלא",
        desc: "תיק מטופל דיגיטלי, קבצים, מסמכים, טפסים חתומים — הכל במקום אחד.",
      },
      {
        title: "יומן + SMS + חשבוניות",
        desc: "ניהול פגישות, תזכורות, אישורי הגעה, ומעקב תשלומים.",
      },
    ],
    testimonialQuote:
      "סוף סוף מערכת שמותאמת לעבודה שלי. הסיכומים האוטומטיים חוסכים לי המון זמן.",
    testimonialAuthor: "יעל מ., מרפאה בעיסוק",
  },

  physiotherapy: {
    slug: "physiotherapy",
    profession: "פיזיותרפיה",
    professionShort: "פיזיותרפיסטים",
    heroTitle: "מערכת ניהול קליניקה לפיזיותרפיה",
    heroSubtitle:
      "הפלטפורמה המושלמת לפיזיותרפיסטים. נהלו מטופלים, תעדו טיפולים ועקבו אחרי תוצאות — הכל בפשטות.",
    metaTitle:
      "CliniKit - תוכנה לניהול קליניקה לפיזיותרפיה | מטופלים, יומן, AI",
    metaDescription:
      "מערכת ניהול קליניקה לפיזיותרפיסטים. פציעות ספורט, שיקום אורתופדי, רצפת אגן, התפתחות הילד. יומן, סיכומי AI, תשלומים. התחילו חינם.",
    color: "#3B82F6",
    emoji: "💪",
    intro:
      "CliniKit מותאמת לפיזיותרפיסטים בכל תחומי ההתמחות — מפציעות ספורט ושיקום אורתופדי ועד רצפת אגן והתפתחות הילד. תועדו טיפולים בצורה מקצועית, עקבו אחרי שיפורים ונהלו את הקליניקה בצורה חכמה.",
    specializations: [
      {
        name: "פציעות ספורט",
        desc: "תיעוד מסלול שיקום, פרוטוקולים ומעקב חזרה לפעילות",
      },
      {
        name: "שיקום אורתופדי",
        desc: "מעקב אחרי ניתוחים, טווחי תנועה ויעדים פונקציונליים",
      },
      {
        name: "רצפת אגן",
        desc: "תבניות הערכה ותיעוד ייעודיים לרצפת אגן",
      },
      {
        name: "פיזיותרפיה נשימתית",
        desc: "תיעוד טיפולים נשימתיים ומעקב תפקוד",
      },
      {
        name: "התפתחות הילד",
        desc: "כלי מעקב התפתחותי ותיעוד אבני דרך מוטוריות",
      },
    ],
    features: [
      {
        title: "סיכומי AI מקצועיים",
        desc: "סיכום טיפול אוטומטי עם מונחים מקצועיים מתחום הפיזיותרפיה.",
      },
      {
        title: "מעקב תוצאות",
        desc: "תיעוד מדידות, טווחי תנועה והתקדמות לאורך טיפולים.",
      },
      {
        title: "ניהול חדרי טיפול",
        desc: "יומן חדרים לקליניקות גדולות — מניעת התנגשויות ותיאום מטפלים.",
      },
      {
        title: "חשבוניות ותשלומים",
        desc: "ניהול פיננסי, הפקת חשבוניות ומעקב חובות — הכל מובנה.",
      },
    ],
    testimonialQuote:
      "המערכת פשוטה ויעילה. חוסכת לי זמן ומאפשרת לי להתרכז במטופלים.",
    testimonialAuthor: "אדם ש., פיזיותרפיסט",
  },

  psychology: {
    slug: "psychology",
    profession: "פסיכולוגיה ופסיכותרפיה",
    professionShort: "פסיכולוגים",
    heroTitle: "תוכנה לניהול מטופלים לפסיכולוגים ופסיכותרפיסטים",
    heroSubtitle:
      "מערכת ניהול קליניקה שמבינה את העבודה של פסיכולוגים. תיעוד מאובטח, סיכומי AI, יומן וניהול מטופלים — בממשק נוח ודיסקרטי.",
    metaTitle:
      "CliniKit - מערכת ניהול קליניקה לפסיכולוגים | תיעוד מאובטח, AI, יומן",
    metaDescription:
      "מערכת ניהול למטפלים בפסיכולוגיה. פסיכולוגיה קלינית, שיקומית, חינוכית, CBT, DBT. תיעוד מאובטח, סיכומי AI, יומן חכם. התחילו חינם.",
    color: "#8B5CF6",
    emoji: "🧠",
    intro:
      "CliniKit מותאמת לפסיכולוגים ו­פסיכותרפיסטים בכל ההתמחויות — קלינית, שיקומית, חינוכית, CBT, DBT ו-LICBT. המערכת מציעה תיעוד מאובטח ברמה הגבוהה ביותר, סיכומי טיפול עם AI שמבין מונחים פסיכולוגיים, ויומן דיסקרטי.",
    specializations: [
      {
        name: "פסיכולוגיה קלינית",
        desc: "תיעוד מפגשים, הערכות אבחנתיות ומעקב טיפולי",
      },
      {
        name: "פסיכולוגיה שיקומית",
        desc: "מעקב יעדים שיקומיים ותפקוד יומיומי",
      },
      {
        name: "פסיכולוגיה חינוכית",
        desc: "תיעוד הערכות, המלצות ומעקב תלמידים",
      },
      { name: "CBT", desc: "תבניות מובנות לטיפול קוגניטיבי-התנהגותי" },
      { name: "LICBT", desc: "כלים למתן טיפול CBT ברמת עצימות נמוכה" },
      { name: "DBT", desc: "מעקב מיומנויות דיאלקטיות ותוכניות טיפול" },
    ],
    features: [
      {
        title: "תיעוד מאובטח",
        desc: "הצפנה מלאה, מאגר מידע רשום, ועמידה בתקני אבטחת מידע רפואי.",
      },
      {
        title: "סיכומי AI פסיכולוגיים",
        desc: "AI שמכיר מונחים פסיכולוגיים ומסכם מפגשים בצורה מקצועית.",
      },
      {
        title: "יומן דיסקרטי",
        desc: "ניהול פגישות עם שמירה מלאה על פרטיות המטופלים.",
      },
      {
        title: "טפסים וחתימות",
        desc: "טפסי הסכמה, שאלונים וחתימה דיגיטלית — הכל דיגיטלי ומאורגן.",
      },
    ],
    testimonialQuote:
      "האבטחה והדיסקרטיות היו קריטיות בשבילי. CliniKit עונה על כל הדרישות.",
    testimonialAuthor: "ד\"ר נועם ל., פסיכולוג קליני",
  },

  emotional_therapy: {
    slug: "emotional-therapy",
    profession: "טיפול רגשי",
    professionShort: "מטפלים רגשיים",
    heroTitle: "מערכת ניהול קליניקה למטפלים רגשיים",
    heroSubtitle:
      "מערכת ניהול שמותאמת למטפלים רגשיים בכל הגישות — אמנות, מוזיקה, פסיכודרמה, טיפול בבעלי חיים ורכיבה טיפולית.",
    metaTitle:
      "CliniKit - מערכת ניהול קליניקה לטיפול רגשי | אמנות, מוזיקה, פסיכודרמה",
    metaDescription:
      "מערכת ניהול למטפלים רגשיים. טיפול באמנות, במוזיקה, פסיכודרמה, טיפול בבעלי חיים, רכיבה טיפולית. סיכומי AI, יומן, תשלומים. חינם.",
    color: "#EC4899",
    emoji: "🎨",
    intro:
      "CliniKit מותאמת למטפלים רגשיים בכל הגישות הטיפוליות — טיפול באמנות, במוזיקה, פסיכודרמה, טיפול בעזרת בעלי חיים ורכיבה טיפולית. תועדו מפגשים עם תבניות מותאמות, קבלו סיכומי AI ונהלו את הקליניקה בנוחות.",
    specializations: [
      {
        name: "טיפול באמנות",
        desc: "תיעוד תהליכים יצירתיים, צירוף תמונות עבודות ומעקב התפתחות",
      },
      {
        name: "טיפול במוזיקה",
        desc: "תיעוד מפגשים מוזיקליים ומעקב תגובות רגשיות",
      },
      {
        name: "פסיכודרמה",
        desc: "תיעוד סצנות, תפקידים ותובנות מהמפגשים",
      },
      {
        name: "טיפול בעזרת בעלי חיים",
        desc: "מעקב אינטראקציות ותגובות במפגשים",
      },
      {
        name: "רכיבה טיפולית",
        desc: "תיעוד מפגשי רכיבה ומעקב יעדים מוטוריים ורגשיים",
      },
    ],
    features: [
      {
        title: "צירוף קבצים ותמונות",
        desc: "העלו תמונות של עבודות אמנות, הקלטות ומסמכים לכל טיפול.",
      },
      {
        title: "סיכומי AI רגשיים",
        desc: "AI שמבין את השפה הטיפולית ומסכם מפגשים בצורה רגישה ומקצועית.",
      },
      {
        title: "יומן גמיש",
        desc: "ניהול פגישות בודדות וקבוצתיות עם תזכורות אוטומטיות.",
      },
      {
        title: "מעקב תהליך",
        desc: "סיכום מטופל חכם שמתעדכן אוטומטית ומציג את מסע הטיפול.",
      },
    ],
    testimonialQuote:
      "אני אוהבת שאפשר לצרף תמונות של עבודות לכל סיכום. המערכת מבינה את הצרכים שלי.",
    testimonialAuthor: "מיכל ר., מטפלת באמנות",
  },

  clinical_social_work: {
    slug: "clinical-social-work",
    profession: "עבודה סוציאלית קלינית",
    professionShort: "עובדים סוציאליים",
    heroTitle: "מערכת ניהול לעובדים סוציאליים קליניים",
    heroSubtitle:
      "פלטפורמה מתקדמת לעובדים סוציאליים קליניים. תיעוד מאובטח, ניהול מקרים, סיכומי AI ומעקב אחרי תהליכים טיפוליים.",
    metaTitle:
      "CliniKit - מערכת ניהול לעובדים סוציאליים קליניים | טראומה, התמכרויות",
    metaDescription:
      "מערכת ניהול לעובדים סוציאליים קליניים. טראומה, התמכרויות, בריאות הנפש בקהילה. תיעוד מאובטח, סיכומי AI, ניהול מקרים. חינם.",
    color: "#F472B6",
    emoji: "🤝",
    intro:
      "CliniKit מותאמת לעובדים סוציאליים קליניים המתמחים בטראומה, התמכרויות ובריאות הנפש בקהילה. תועדו מקרים בצורה מאובטחת, קבלו סיכומי AI מקצועיים ונהלו את כל ה­case load בממשק אחד.",
    specializations: [
      {
        name: "טראומה",
        desc: "כלי תיעוד מותאמים לטיפול בטראומה ו-PTSD",
      },
      {
        name: "התמכרויות",
        desc: "מעקב תהליך גמילה ותיעוד התקדמות",
      },
      {
        name: "בריאות הנפש בקהילה",
        desc: "ניהול מקרים מורכבים ותיאום עם גורמים חיצוניים",
      },
    ],
    features: [
      {
        title: "ניהול מקרים",
        desc: "תיק דיגיטלי מלא עם היסטוריית טיפולים, מסמכים וקבצים.",
      },
      {
        title: "תיעוד מאובטח",
        desc: "אבטחה ברמה הגבוהה ביותר עם הצפנה מלאה ושמירה על סודיות.",
      },
      {
        title: "סיכומי AI",
        desc: "סיכום מפגשים אוטומטי שחוסך שעות של כתיבה.",
      },
      {
        title: "טפסים וחתימות",
        desc: "טפסי הסכמה ושאלונים עם חתימה דיגיטלית מהטלפון.",
      },
    ],
    testimonialQuote:
      "המעבר ל-CliniKit חסך לי שעות של עבודת תיעוד. הסיכומים של ה-AI מדויקים.",
    testimonialAuthor: "שרית כ., עו\"ס קלינית",
  },

  parenting_counseling: {
    slug: "parenting-counseling",
    profession: "הדרכת הורים וייעוץ משפחתי",
    professionShort: "מדריכי הורים",
    heroTitle: "מערכת ניהול למדריכי הורים ויועצים משפחתיים",
    heroSubtitle:
      "הפלטפורמה למדריכי הורים, יועצי שינה, ומתמחים בהפרעות קשב. נהלו הורים ומשפחות, תעדו מפגשים ועקבו אחרי ההתקדמות.",
    metaTitle:
      "CliniKit - מערכת ניהול להדרכת הורים וייעוץ משפחתי | שינה, ADHD, גמילה",
    metaDescription:
      "מערכת ניהול למדריכי הורים ויועצים משפחתיים. ייעוץ שינה, גמילה, ADHD, גיל ההתבגרות, קשיי ויסות. סיכומי AI, יומן, תשלומים. חינם.",
    color: "#F97316",
    emoji: "👨‍👩‍👧",
    intro:
      "CliniKit מותאמת למדריכי הורים ויועצים משפחתיים בכל ההתמחויות — ייעוץ שינה, גמילה, הפרעות קשב, גיל ההתבגרות וקשיי ויסות. תועדו מפגשים, שלחו משימות להורים ועקבו אחרי ההתקדמות של המשפחה.",
    specializations: [
      {
        name: "ייעוץ שינה",
        desc: "תיעוד תוכניות שינה, מעקב יומני שינה והתקדמות",
      },
      {
        name: "גמילה",
        desc: "תוכניות גמילה מותאמות ומעקב לאורך זמן",
      },
      {
        name: "הפרעות קשב (ADHD)",
        desc: "כלי מעקב ותיעוד ייעודיים להפרעות קשב",
      },
      {
        name: "גיל ההתבגרות",
        desc: "ליווי הורים ומתבגרים עם תיעוד מותאם",
      },
      {
        name: "קשיי ויסות",
        desc: "מעקב התנהגותי ותיעוד אסטרטגיות ויסות",
      },
    ],
    features: [
      {
        title: "סיכומי מפגשים עם AI",
        desc: "תיעוד אוטומטי של מפגשי הדרכה עם המלצות ומשימות להורים.",
      },
      {
        title: "שליחת משימות",
        desc: "שלחו משימות והנחיות להורים ישירות מהמערכת.",
      },
      {
        title: "יומן גמיש",
        desc: "ניהול מפגשים בודדים וסדרות הדרכה עם תזכורות.",
      },
      {
        title: "ניהול פיננסי",
        desc: "מעקב תשלומים, חבילות הדרכה וחשבוניות.",
      },
    ],
    testimonialQuote:
      "המערכת מאפשרת לי להיות יותר מאורגנת ולתת שירות טוב יותר למשפחות.",
    testimonialAuthor: "דנה ת., יועצת שינה ומדריכת הורים",
  },

  personal_coaching: {
    slug: "personal-coaching",
    profession: "אימון אישי",
    professionShort: "מאמנים אישיים",
    heroTitle: "מערכת ניהול למאמנים אישיים",
    heroSubtitle:
      "הפלטפורמה למאמנים אישיים, עסקיים ולקריירה. נהלו לקוחות, תעדו מפגשים ועקבו אחרי היעדים — בממשק מקצועי ונוח.",
    metaTitle: "CliniKit - מערכת ניהול למאמנים אישיים | אימון עסקי, קריירה",
    metaDescription:
      "מערכת ניהול למאמנים אישיים. אימון עסקי, קריירה, זוגיות, ניהול זמן. ניהול לקוחות, סיכומי AI, יומן, תשלומים. התחילו חינם.",
    color: "#10B981",
    emoji: "🎯",
    intro:
      "CliniKit מותאמת למאמנים אישיים בכל ההתמחויות — אימון עסקי, קריירה, מציאת זוגיות וניהול זמן. תועדו מפגשי אימון, עקבו אחרי יעדים ונהלו את הלקוחות בצורה מקצועית.",
    specializations: [
      {
        name: "אימון עסקי",
        desc: "מעקב יעדים עסקיים ותיעוד אסטרטגיות",
      },
      {
        name: "אימון למציאת זוגיות",
        desc: "תיעוד תהליך ומעקב התקדמות אישית",
      },
      {
        name: "אימון לקריירה",
        desc: "מעקב שלבי קריירה, קורות חיים ויעדים",
      },
      {
        name: "אימון לניהול זמן",
        desc: "כלי מעקב והגדרת יעדים לניהול זמן אפקטיבי",
      },
    ],
    features: [
      {
        title: "מעקב יעדים",
        desc: "הגדירו יעדים ללקוחות ועקבו אחרי ההתקדמות בכל מפגש.",
      },
      {
        title: "סיכומי AI",
        desc: "סיכום אוטומטי של מפגשי אימון עם נקודות מפתח ומשימות.",
      },
      {
        title: "ניהול לידים",
        desc: "מעקב לקוחות פוטנציאליים והמרתם ללקוחות בקליק.",
      },
      {
        title: "חשבוניות וגבייה",
        desc: "ניהול חבילות אימון, תשלומים וחשבוניות — הכל אוטומטי.",
      },
    ],
    testimonialQuote:
      "CliniKit עזרה לי להיות מאמן מקצועי יותר. הלקוחות שלי מרגישים את ההבדל.",
    testimonialAuthor: "אורי כ., מאמן אישי ועסקי",
  },

  couples_counseling: {
    slug: "couples-counseling",
    profession: "ייעוץ זוגי ומיני",
    professionShort: "יועצי זוגיות",
    heroTitle: "מערכת ניהול ליועצים זוגיים ומיניים",
    heroSubtitle:
      "פלטפורמה מאובטחת ליועצי זוגיות, מגשרים משפחתיים ומטפלים מיניים. תיעוד דיסקרטי, סיכומי AI וניהול מפגשים.",
    metaTitle:
      "CliniKit - מערכת ניהול ליועצים זוגיים ומיניים | גישור, טיפול זוגי",
    metaDescription:
      "מערכת ניהול ליועצי זוגיות. גישור משפחתי, ייעוץ לפני נישואין, טיפול מיני. תיעוד מאובטח, סיכומי AI, יומן. התחילו חינם.",
    color: "#EF4444",
    emoji: "💑",
    intro:
      "CliniKit מותאמת ליועצי זוגיות ומטפלים מיניים — גישור משפחתי, ייעוץ לפני נישואין וטיפול מיני. המערכת מציעה תיעוד מאובטח ודיסקרטי, סיכומי AI ו­ניהול מפגשים בממשק מקצועי.",
    specializations: [
      {
        name: "גישור משפחתי",
        desc: "תיעוד תהליכי גישור ומעקב הסכמות",
      },
      {
        name: "ייעוץ לפני נישואין",
        desc: "מבנה מפגשים מותאם וסיכומי התקדמות",
      },
      {
        name: "טיפול מיני",
        desc: "תיעוד מאובטח ודיסקרטי ברמה הגבוהה ביותר",
      },
    ],
    features: [
      {
        title: "פרטיות מוחלטת",
        desc: "אבטחה ודיסקרטיות ברמה הגבוהה ביותר. המידע מוצפן ומוגן.",
      },
      {
        title: "סיכומי AI",
        desc: "סיכום מפגשים אוטומטי שמכבד את רגישות התחום.",
      },
      {
        title: "ניהול זוגות",
        desc: "תיק לכל זוג/משפחה עם היסטוריה מלאה של מפגשים.",
      },
      {
        title: "יומן + תשלומים",
        desc: "ניהול פגישות, תזכורות ומעקב פיננסי מלא.",
      },
    ],
    testimonialQuote:
      "הדיסקרטיות של המערכת חשובה מאוד בתחום שלי. CliniKit עונה על זה בצורה מושלמת.",
    testimonialAuthor: "רון ד., יועץ זוגי",
  },

  nutrition: {
    slug: "nutrition",
    profession: "תזונה ודיאטה",
    professionShort: "תזונאים",
    heroTitle: "מערכת ניהול קליניקה לתזונאים ודיאטנים",
    heroSubtitle:
      "הפלטפורמה לתזונאים, דיאטנים ומטפלים בהפרעות אכילה. נהלו מטופלים, תעדו מפגשים ועקבו אחרי ההתקדמות.",
    metaTitle:
      "CliniKit - מערכת ניהול קליניקה לתזונאים ודיאטנים | דיאטה, ספורט",
    metaDescription:
      "מערכת ניהול לתזונאים. דיאטה קלינית, תזונת ספורט, הפרעות אכילה, תזונת ילדים. ניהול מטופלים, סיכומי AI, יומן. חינם.",
    color: "#84CC16",
    emoji: "🥗",
    intro:
      "CliniKit מותאמת לתזונאים ודיאטנים בכל תחומי ההתמחות — דיאטה קלינית, תזונת ספורט, הפרעות אכילה ותזונת ילדים. תועדו מפגשים, עקבו אחרי התקדמות מטופלים ונהלו את הקליניקה בנוחות.",
    specializations: [
      {
        name: "דיאטה קלינית (סוכרת/לב)",
        desc: "מעקב תפריטים, בדיקות דם והתקדמות קלינית",
      },
      {
        name: "תזונת ספורט",
        desc: "תוכניות תזונה מותאמות לספורטאים ומעקב ביצועים",
      },
      {
        name: "הפרעות אכילה",
        desc: "תיעוד רגיש ומעקב תהליך שיקום",
      },
      {
        name: "תזונה לילדים",
        desc: "מעקב גדילה, הרגלי אכילה ותפריטים מותאמים",
      },
    ],
    features: [
      {
        title: "סיכומי מפגשים AI",
        desc: "סיכום אוטומטי של מפגשי ייעוץ תזונתי עם המלצות.",
      },
      {
        title: "מעקב התקדמות",
        desc: "מעקב מדדים, משקל, ואיכות תזונה לאורך זמן.",
      },
      {
        title: "שליחת תוכניות",
        desc: "שלחו תוכניות תזונה ומשימות ישירות למטופלים.",
      },
      {
        title: "ניהול פיננסי",
        desc: "ניהול חבילות ייעוץ, תשלומים וחשבוניות.",
      },
    ],
    testimonialQuote:
      "המערכת עוזרת לי לעקוב אחרי כל מטופל ולתת שירות מקצועי ואישי.",
    testimonialAuthor: "ליאת ק., דיאטנית קלינית",
  },

  naturopathy: {
    slug: "naturopathy",
    profession: "נטורופתיה ורפואה טבעית",
    professionShort: "נטורופתים",
    heroTitle: "מערכת ניהול לנטורופתים ומטפלים ברפואה טבעית",
    heroSubtitle:
      "פלטפורמה מותאמת לנטורופתים, מטפלים בצמחי מרפא ופרחי באך. תועדו טיפולים, נהלו מטופלים ועקבו אחרי תוצאות.",
    metaTitle:
      "CliniKit - מערכת ניהול לנטורופתים ורפואה טבעית | צמחי מרפא, פרחי באך",
    metaDescription:
      "מערכת ניהול לנטורופתים. צמחי מרפא, אירידיאולוגיה, פרחי באך. ניהול מטופלים, סיכומי AI, יומן, תשלומים. התחילו חינם.",
    color: "#22C55E",
    emoji: "🌿",
    intro:
      "CliniKit מותאמת לנטורופתים ומטפלים ברפואה טבעית בכל ההתמחויות — צמחי מרפא, אירידיאולוגיה ופרחי באך. תועדו טיפולים, נהלו מרשמים טבעיים ועקבו אחרי התקדמות המטופלים.",
    specializations: [
      {
        name: "צמחי מרפא",
        desc: "תיעוד מרשמים צמחיים ומעקב תגובות",
      },
      {
        name: "אירידיאולוגיה",
        desc: "תיעוד אבחנות קשתית העין עם צירוף תמונות",
      },
      {
        name: "פרחי באך",
        desc: "מעקב תערובות ושינויים רגשיים לאורך זמן",
      },
    ],
    features: [
      {
        title: "תיעוד מרשמים",
        desc: "תיעוד מפורט של מרשמים טבעיים, מינונים ומעקב תגובות.",
      },
      {
        title: "צירוף תמונות",
        desc: "העלו תמונות אבחנה, צמחים ותיעוד ויזואלי לכל מפגש.",
      },
      {
        title: "סיכומי AI",
        desc: "סיכום טיפולים אוטומטי עם המלצות המשך.",
      },
      {
        title: "יומן + ניהול פיננסי",
        desc: "ניהול פגישות, תזכורות, תשלומים וחשבוניות.",
      },
    ],
    testimonialQuote:
      "סוף סוף מערכת שמתאימה גם לרפואה טבעית ולא רק לקונבנציונלית.",
    testimonialAuthor: "יובל ג., נטורופת",
  },

  chinese_medicine: {
    slug: "chinese-medicine",
    profession: "רפואה סינית ומשלימה",
    professionShort: "מטפלים ברפואה סינית",
    heroTitle: "מערכת ניהול לרפואה סינית ומשלימה",
    heroSubtitle:
      "פלטפורמה למטפלים בדיקור סיני, שיאצו, טווינא ורפלקסולוגיה. תועדו טיפולים, נהלו מטופלים ועקבו אחרי ההתקדמות.",
    metaTitle:
      "CliniKit - מערכת ניהול לרפואה סינית ומשלימה | דיקור, שיאצו, רפלקסולוגיה",
    metaDescription:
      "מערכת ניהול לרפואה סינית. דיקור סיני, שיאצו, טווינא, רפלקסולוגיה. ניהול מטופלים, סיכומי AI, יומן, תשלומים. חינם.",
    color: "#A855F7",
    emoji: "🪷",
    intro:
      "CliniKit מותאמת למטפלים ברפואה סינית ומשלימה — דיקור סיני, שיאצו, טווינא ורפלקסולוגיה. תועדו טיפולים עם תבניות מותאמות, נהלו מטופלים ועקבו אחרי תוצאות הטיפול.",
    specializations: [
      {
        name: "דיקור סיני (Acupuncture)",
        desc: "תיעוד נקודות דיקור, תוכניות טיפול ומעקב תגובות",
      },
      {
        name: "שיאצו",
        desc: "תיעוד טיפולים, אזורי לחץ ומעקב שיפור",
      },
      {
        name: "טווינא",
        desc: "תיעוד טכניקות עיסוי ומעקב תוצאות",
      },
      {
        name: "רפלקסולוגיה",
        desc: "מיפוי אזורים, תיעוד ממצאים ומעקב טיפולי",
      },
    ],
    features: [
      {
        title: "תבניות מותאמות",
        desc: "תבניות סיכום טיפול מותאמות לרפואה סינית ומשלימה.",
      },
      {
        title: "סיכומי AI",
        desc: "AI שמבין את המונחים של הרפואה הסינית ומסכם טיפולים.",
      },
      {
        title: "ניהול מטופלים",
        desc: "תיק מטופל מלא עם היסטוריה, מסמכים וקבצים.",
      },
      {
        title: "חשבוניות ותשלומים",
        desc: "ניהול פיננסי מלא — מעקב תשלומים, חובות וחשבוניות.",
      },
    ],
    testimonialQuote:
      "המערכת מאפשרת לי לתעד טיפולים בצורה שמתאימה לרפואה סינית. ממליץ בחום.",
    testimonialAuthor: "עמית ב., מטפל ברפואה סינית",
  },
};

export const getLandingPageBySlug = (slug) =>
  Object.values(LANDING_PAGES).find((page) => page.slug === slug);

export const ALL_LANDING_SLUGS = Object.values(LANDING_PAGES).map(
  (page) => page.slug
);
